import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SmartPhrasesPanel = ({ phrases, onPhraseSelect }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All Phrases', count: phrases?.length },
    { id: 'assessment', label: 'Assessment', count: phrases?.filter(p => p?.category === 'assessment')?.length },
    { id: 'plan', label: 'Plan', count: phrases?.filter(p => p?.category === 'plan')?.length },
    { id: 'history', label: 'History', count: phrases?.filter(p => p?.category === 'history')?.length }
  ];

  const filteredPhrases = phrases?.filter(phrase => {
    const matchesSearch = phrase?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
                         phrase?.content?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || phrase?.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden h-full flex flex-col">
      <div className="p-4 border-b border-border bg-muted/30">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center justify-center w-10 h-10 bg-secondary/10 rounded-lg">
            <Icon name="Zap" size={20} color="var(--color-secondary)" />
          </div>
          <div>
            <h3 className="text-sm md:text-base font-semibold text-foreground">Smart Phrases</h3>
            <p className="text-xs text-muted-foreground">Quick text templates</p>
          </div>
        </div>

        <Input
          type="search"
          placeholder="Search phrases..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          className="mb-3"
        />

        <div className="flex gap-2 overflow-x-auto pb-2">
          {categories?.map((cat) => (
            <button
              key={cat?.id}
              onClick={() => setSelectedCategory(cat?.id)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-smooth flex-shrink-0 ${
                selectedCategory === cat?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              <span>{cat?.label}</span>
              <span className={`px-1.5 py-0.5 rounded text-xs ${
                selectedCategory === cat?.id ? 'bg-primary-foreground/20' : 'bg-background'
              }`}>
                {cat?.count}
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-2">
        {filteredPhrases?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-center p-6">
            <Icon name="Search" size={48} color="var(--color-muted-foreground)" className="mb-3" />
            <p className="text-sm text-muted-foreground">No phrases found</p>
          </div>
        ) : (
          filteredPhrases?.map((phrase) => (
            <button
              key={phrase?.id}
              onClick={() => onPhraseSelect(phrase)}
              className="w-full text-left p-3 bg-muted/50 rounded-lg hover:bg-muted transition-smooth"
            >
              <div className="flex items-start justify-between gap-2 mb-2">
                <p className="text-sm font-semibold text-foreground">{phrase?.title}</p>
                <span className="text-xs px-2 py-1 bg-background rounded text-muted-foreground flex-shrink-0">
                  {phrase?.shortcut}
                </span>
              </div>
              <p className="text-xs text-muted-foreground line-clamp-2">{phrase?.content}</p>
              <div className="flex items-center gap-2 mt-2">
                <span className="text-xs px-2 py-1 bg-primary/10 text-primary rounded">{phrase?.category}</span>
                <span className="text-xs text-muted-foreground">{phrase?.usageCount} uses</span>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default SmartPhrasesPanel;